import type { Event } from '@/types/event';
import type { BoundingBoxData } from '@/types/video-player';

interface BuildBoundingBoxPropsParams {
    event: Event;
    focuses?: number[][];
}

export function buildBoundingBoxProps({
    event,
    focuses,
}: BuildBoundingBoxPropsParams): BoundingBoxData | undefined {
    if (!event.frames || event.frames.length === 0) return undefined;
    return {
        id: event.id,
        frames: event.frames,
        snapshotFrameId: event.snapshotFrameId,
        focuses: focuses ?? [],
        drawBoxes: event.type !== 'SCENE',
    };
}
